import { useQuery } from "react-query";
import queryKeys from "../../../constants/queryKeys";
import auditService from "../../services/auditService";
import reactQueryUtils from "../../../utils/reactQueryUtils";

const useSiteMeridianAudits = ({ siteExternalId, pageNum, pageSize }) => 
    useQuery(
        [queryKeys.siteMeridianAudits, siteExternalId, pageNum, pageSize],
        () => auditService.getBySiteExternalId({ siteExternalId, pageNum, pageSize }),
        {
            enabled: !!siteExternalId,
        }
    );

export const invalidate = ({ siteExternalId, pageNum, pageSize }) => reactQueryUtils.client.invalidateQueries([queryKeys.siteMeridianAudits, siteExternalId, pageNum, pageSize]);

export default useSiteMeridianAudits;